import React from "react";
import "./dashboard.css";
import { useDashboard } from "./useDashboard";
import { Redirect, Route, Switch } from "react-router-dom";
import Menu from "../../component/Menu/Menu";
import Absensi from "../SubMenu/Absensi";
import Payroll from "../SubMenu/Payroll";
import RekapAbsensi from "../SubMenu/RekapAbsensi/RekapAbsensi";
import PayrollHistory from "../SubMenu/PayrollHistory/PayrollHistory";
import EditUser from "../SubMenu/EditUser/EditUser";
import AddUser from "../SubMenu/AddUser/AddUser";
import Kasbon from "../SubMenu/Kasbon";
import WhiteList from "../SubMenu/Whitelist/WhiteList";
import PatrolSecurity from "../SubMenu/PatrolSecurity/PatrolSecurity";
import LiburTahunan from "../SubMenu/LiburTahunan/LiburTahunan";
import FormLembur from "../SubMenu/FormLembur/FormLembur";
import NewsLetter from "../SubMenu/NewsLetter/NewsLetter";
import MonitoringApar from "../SubMenu/APAR/monitoringApar";
import ListRequest from "../SubMenu/ListRequest/ListRequest";

const Dashboard = () => {
  const { statusCode } = useDashboard();

  return (
    <>
      {statusCode === 404 ? (
        <Redirect push to="/login" />
      ) : (
        <>
          <Menu />
          <div className="container_dashboard">
            <Switch>
              <Route exact path="/absensi" component={Absensi} />
              <Route exact path="/request" component={ListRequest} />
              <Route exact path="/payroll" component={Payroll} />
              <Route exact path="/RekapAbsensi" component={RekapAbsensi} />
              <Route exact path="/payrollHistory" component={PayrollHistory} />
              <Route exact path="/editUser" component={EditUser} />
              <Route exact path="/addUser" component={AddUser} />
              <Route exact path="/kasbon" component={Kasbon} />
              <Route exact path="/whiteList" component={WhiteList} />
              <Route exact path="/patrolSecurity" component={PatrolSecurity} />
              <Route exact path="/liburTahunan" component={LiburTahunan} />
              <Route exact path="/formLembur" component={FormLembur} />
              <Route exact path="/newsLetter" component={NewsLetter} />
              <Route exact path="/APAR" component={MonitoringApar} />
              <Redirect to="/absensi" />
            </Switch>
          </div>
        </>
      )}
    </>
  );
};
export default Dashboard;
